// extracted by mini-css-extract-plugin
module.exports = {"Legal":"SignupFields_Legal__ifPkf","EmailOptIn":"SignupFields_EmailOptIn__ROsVP"};